// removed by extract-text-webpack-plugin
module.exports = {"appBar":"strategies__appBar___2B544","leftIcon":"strategies__leftIcon___1aoFW","non-style-button":"strategies__non-style-button___1iQRq"};


//////////////////
// WEBPACK FOOTER
// ./src/component/strategies/strategies.scss
// module id = 375
// module chunks = 0